import NavAndSearch from './NavAndSearch'
import SubField from './SubField'

export default function FieldTables({ fields }) {

  // sort unique categories
  // https://codeburst.io/javascript-array-distinct-5edc93501dc4
  const categories = fields.map(field => field.category)
  const uniqueCategories = [...new Set(categories)].sort()
  // console.log(uniqueCategories)

  function findFieldsInCategories(categoryLookup) {
    return fields.filter((field) => field.category === categoryLookup)
  }

  function displayOptions(field) {
    const options = [field.option1, field.option2, field.option3, field.option4, field.option5, field.option6, field.option7, field.option8, field.option9, field.option10]
    return options.filter((option) => option !== null)
  }

  return (
    <div>
      <NavAndSearch />
      <div style={{ marginTop: '4.5rem' }}>
        {uniqueCategories.map((category) => (
          <SubField
            key={`SubField-${category}`}
            category={category}
            categoryFields={findFieldsInCategories(category)}
            displayOptions={displayOptions}
          />
        ))}
      </div>
    </div>
  )
}
